module.exports = __webpack_public_path__ + "static/media/4.9b34e7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/4.png
// module id = 887
// module chunks = 0